import { useCallback, useRef, useState } from 'react';

export function useLoading() {
  const loadingRef = useRef(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const action = useCallback(<T>(fn: () => T) => {
    if (loadingRef.current) return;
    loadingRef.current = true;
    setIsLoading(true);
    const result = fn();
    if (result instanceof Promise) {
      return result.finally(() => {
        setIsLoading(false);
        loadingRef.current = false;
      });
    }
    setIsLoading(false);
    loadingRef.current = false;
    return result;
  }, []);

  return [isLoading, action] as const;
}
